<template>
    <div id="source_upgrades" class="container-fluid">

        <h2>Обновление источника композиций</h2>

        <template v-if="!selectedSource">

            <template v-if="availableSources.length === 0">
                <p>У вас нет доступа ни к одному из дополнительных источников записей.</p>
            </template>

            <template v-else>
                <p>
                    Выберите источник — для каждого будут показаны танды, в которых композиции сейчас
                    взяты из источника Entropy, хотя для этих же записей доступны экземпляры из выбранного
                    источника.
                </p>
                <ul class="source-picker">
                    <li v-for="src in availableSources" :key="src">
                        <a class="clickable" @click="chooseSource(src)">{{ src }} <octicon name="chevron-right"></octicon></a>
                    </li>
                </ul>
            </template>

        </template>

        <template v-else>

            <p><a class="clickable back-link" @click="reset"><octicon name="chevron-left"></octicon> выбрать другой источник</a></p>

            <template v-if="forbidden">
                <p>У вас больше нет доступа к источнику «{{ selectedSource }}».</p>
            </template>

            <template v-else-if="loaded">

                <h4 class="source-title">Источник: {{ selectedSource }}</h4>

                <div v-if="tandas.length === 0" class="empty-state">
                    Нет доступных предложений по обновлению — все ваши танды уже используют лучший доступный источник.
                </div>

                <template v-else>

                    <div class="tanda-block" v-for="tanda in tandas" :key="tanda.id">
                        <h4>
                            <router-link :to="'/tandas/'+tanda.id+'/'">{{ tanda.title || 'Без названия' }}</router-link>
                            <span class="tanda-meta"> — {{ tanda.orchestra || 'MIXED' }}, {{ tanda.genre }}</span>
                        </h4>
                        <table class="table table-sm suggestions">
                            <thead>
                                <tr>
                                    <th class="col-check"></th>
                                    <th>Композиция</th>
                                    <th>Сейчас</th>
                                    <th></th>
                                    <th>Предлагается</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="s in tanda.suggestions" :key="s.entry_id">
                                    <td class="col-check">
                                        <input type="checkbox" :id="'sugg_'+s.entry_id" v-model="selected" :value="s.entry_id"/>
                                    </td>
                                    <td><label :for="'sugg_'+s.entry_id">{{ s.song_title }}</label></td>
                                    <td><span class="badge badge-lp-entropy">{{ s.current_instance.source }}</span></td>
                                    <td class="col-arrow"><octicon name="chevron-right"></octicon></td>
                                    <td><span class="badge" :class="'badge-lp-'+s.suggested_instance.source">{{ s.suggested_instance.source }}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="apply-bar">
                        <button class="btn btn-sm btn-outline-secondary" @click="selectAll">Выбрать всё</button>
                        <button class="btn btn-sm btn-outline-secondary" @click="selectNone">Снять выбор</button>
                        <button class="btn btn-small btn-success" :disabled="selected.length === 0 || applying" @click="apply">
                            <octicon name="check"></octicon> Применить выбранные изменения ({{ selected.length }})
                        </button>
                    </div>

                </template>

            </template>

        </template>

    </div>
</template>

<script>

    import axios from 'axios'
    import { tdj2 } from '@/tdj2.js'

    export default {
        name: 'SourceUpgrades',

        data() {
            return {
                state: tdj2.state,
                selectedSource: null,
                loaded: false,
                forbidden: false,
                applying: false,
                tandas: [],
                selected: []
            }
        },

        computed: {
            availableSources() {
                return this.state.profile.enabled_private_sources || []
            }
        },

        methods: {

            chooseSource(src) {
                this.selectedSource = src
                this.loaded = false
                this.forbidden = false
                this.tandas = []
                this.selected = []
                this.fetchSuggestions()
            },

            reset() {
                this.selectedSource = null
                this.loaded = false
                this.forbidden = false
                this.tandas = []
                this.selected = []
            },

            fetchSuggestions() {
                axios.get('/api/tandas/source_suggestions/', { params: { source: this.selectedSource }, tdj2SkipGlobalErrorNotify: true })
                .then((result) => {
                    this.tandas = result.data.tandas
                    this.loaded = true
                    this.forbidden = false
                })
                .catch((error) => {
                    if (error.response && error.response.status === 403) {
                        this.forbidden = true
                    } else {
                        tdj2.notify_error('Ошибка загрузки предложений по обновлению', error)
                    }
                })
            },

            selectAll() {
                this.selected = this.tandas.flatMap((t) => t.suggestions.map((s) => s.entry_id))
            },

            selectNone() {
                this.selected = []
            },

            apply() {
                if (this.selected.length === 0) {
                    return
                }
                this.applying = true
                axios.post('/api/tandas/source_apply/', { source: this.selectedSource, entry_ids: this.selected }, { tdj2SkipGlobalErrorNotify: true })
                .then((result) => {
                    this.applying = false
                    this.selected = []
                    tdj2.notify_success('Обновлено композиций: ' + result.data.applied.length)
                    this.fetchSuggestions()
                })
                .catch((error) => {
                    this.applying = false
                    tdj2.notify_error('Ошибка применения изменений', error)
                })
            }

        }

    }

</script>

<style lang="less" scoped>

    .source-picker {
        list-style: none;
        padding-left: 0;
        margin-top: 20px;

        li {
            margin-bottom: 10px;
            font-size: 12pt;
        }
    }

    .back-link {
        display: inline-block;
        margin-bottom: 10px;
    }

    .source-title {
        margin-bottom: 20px;
    }

    .empty-state {
        color: #999999;
        margin-top: 20px;
    }

    .tanda-block {
        margin-bottom: 30px;

        h4 {
            margin-bottom: 10px;
        }

        .tanda-meta {
            font-size: 10pt;
            color: #999999;
            font-weight: normal;
        }
    }

    table.suggestions {
        .col-check {
            width: 30px;
        }
        .col-arrow {
            width: 30px;
            text-align: center;
            color: #999999;
        }
        label {
            cursor: pointer;
            margin-bottom: 0;
        }
    }

    .apply-bar {
        position: sticky;
        bottom: 0;
        background: white;
        padding: 15px 0;
        border-top: 1px solid #eeeeee;

        button {
            margin-right: 10px;
        }
    }

</style>
